import React from 'react';
import Dialog from 'material-ui/Dialog';
import { RadioButton, RadioButtonGroup } from 'material-ui/RadioButton';
// import _ from 'lodash';

const customContentStyle = {
  height   : '100%',
  maxHeight: 'none'
};

export default class QuizModal extends React.Component {
  state = {
    cpd_quiz: [
      {
        question: '',
        correct: ''
      }
    ]
  };

  setStylesApp = () => {
    document.getElementById('app').style.position = 'fixed';
    document.getElementById('app').style.width = '100%';
  };

  renderQuizContainer = ({
    quizNumber,
    nextQuestion,
    submitAnswers,
    quiz,
    onAnswerEdit,
    answer
  }) => (
    <form className="create-category form-modal">
      <div className="desc" style={{margin: '20px 0'}}>
        {quiz.question}
      </div>
      <div className="input-wrap main">
        <RadioButtonGroup
          name="correct"
          onChange={onAnswerEdit}
          valueSelected={answer[quiz.id]}
          className='select-answer-wrapper'
          style={{display: 'flex'}}
        >
          <RadioButton
            id={quiz.id}
            value="true"
            label="TRUE"
            style={{ marginRight: 50, width: 'unset' }}
          />
          <RadioButton
            id={quiz.id}
            value="false"
            label="FALSE"
          />
        </RadioButtonGroup>
      </div>
      <div className="button-set" style={{textAlign: 'left'}}>
        <button
          className="btn blue rounded submit-btn"
          disabled={!answer[quiz.id]}
          onClick={quizNumber === 9 ? submitAnswers : nextQuestion}
        >
          SUBMIT
        </button>
      </div>
    </form>
  );

  renderResultContainer = ({quizResult, closeQuizModal}) => (
    <div className="create-category form-modal" style={{textAlign: 'center'}}>
      <h1 style={{
        color: quizResult >= 8 ? '#28b5f4' : 'grey',
        textAlign: 'center',
        fontSize: '24px'
      }}>{`${quizResult >= 8 ? 'Congratulations!' : 'Better luck next time!'}`}</h1>
      <h3 style={{margin: '20px 0'}}>
        {`${quizResult >= 8 ?
          'Congratulations! You have passed the CPD quiz for this module' :
          'You need to answer at least 8 questions to pass this CPD quiz'
        }`}
      </h3>
      { quizResult >= 8 &&
        <div className="desc" style={{margin: '20px 0'}}>
          {`You have answered ${quizResult} out of 10 questions correctly`}
        </div>
      }
      <div className="button-set" style={{textAlign: 'center'}}>
        <button
          className="btn blue rounded submit-btn"
          onClick={closeQuizModal}
        >
          {`${quizResult >= 8 ? 'WELL DONE' : 'CLOSE'}`}
        </button>
      </div>
    </div>
  );

  render() {
    const {
      quizNumber,
      isOpenQuizModal,
      closeQuizModal,
      quizResult
    } = this.props;
    const modalTitle = !quizResult ? `Question ${quizNumber + 1}/10` : '';

    return (
        <Dialog
          className="modal-wrapper"
          title={modalTitle}
          modal={true}
          open={isOpenQuizModal}
          customContentStyle={customContentStyle}
          bodyClassName="modal-content"
          repositionOnUpdate={true}
          autoDetectWindowHeight={true}
          autoScrollBodyContent={false}
          titleStyle={{paddingTop: '48px'}}
          contentStyle={{
            width    : '100%',
            maxHeight: '100% !important'
          }}
          bodyStyle={{
            maxHeight: '100% !important'
          }}
          style={{
            paddingTop: '0 !important',
            marginTop : '-65px !important',
            bottom    : '0 !important',
            overflow  : 'scroll !important',
            height    : 'auto !important'
          }}
        >
          <button
            className="ic ic-close delete-category-btn modal"
            style={{
              position: 'absolute',
              top: '10px',
              right: '10px',
              border: 0,
              cursor: 'pointer',
              fontSize: '24px',
              color: 'grey'
            }}
            onClick={closeQuizModal}
            type="button"
          />
          { quizResult || quizResult === 0 ?
            this.renderResultContainer(this.props) :
            this.renderQuizContainer(this.props)
          }
        </Dialog>)
  }
}



// WEBPACK FOOTER //
// ./src/modules/tutorial/components/QuizModal.js